import { cn } from '@/utils/styles';

interface Props {
  label: string;
  isActive?: boolean;
}

const VehicleTypeBadge = ({ label, isActive }: Props) => {
  return (
    <p
      className={cn(
        'm-0 mr-2 inline-block whitespace-nowrap rounded bg-grey-100 px-1 text-xs leading-5 text-grey-500',
        isActive && 'bg-lightBlue-50 text-lightBlue-800',
      )}
    >
      {label}
    </p>
  );
};

export { VehicleTypeBadge };
